import { useState, useEffect, useRef } from "react";
import NavButton from "./NavButton";
import MainaIcon from "./MainaIcon";
import CardIcon from "./CardIcon";
import Card2Icon from "./Card2Icon";
import Certification from "./CertificationIcon";

function Nav({config}) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navRef = useRef(null);
  const [activeTab, setActiveTab] = useState("tab3");

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleClick = (tab) => {
    if (isMobile && navRef.current ) {
      navRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setActiveTab(tab);
  }

  return (
    <div className="bg-slate-100 px-4 pt-0 pb-4 sm:pt-8 lg:px-8 lg:pb-8 mx-auto">
      <nav
        className="max-w-4xl mx-auto grid rounded-xl sm:flex sm:gap-x-4 gap-y-4 bg-gradient-to-tl from-blue-200 to-blue-100 p-4"
        aria-label="Tabs"
        role="tablist"
        ref={navRef}
      >
        {config.show_oldcard && <NavButton
          isActive={activeTab === "tab3"}
          onClick={() => handleClick("tab3")}
          id="tabs-with-card-item-3"
          controls="tabs-with-card-3"
          title="健康保険証"
          description=""
        >
          <CardIcon />
        </NavButton>}
        {config.show_maina && <NavButton
          isActive={activeTab === "tab1"}
          onClick={() => handleClick("tab1")}
          id="tabs-with-card-item-1"
          controls="tabs-with-card-1"
          title="マイナポータル"
          description=""
        >
          <MainaIcon />
        </NavButton>}
        {config.show_notification && <NavButton
          isActive={activeTab === "tab2"}
          onClick={() => handleClick("tab2")}
          id="tabs-with-card-item-2"
          controls="tabs-with-card-2"
          title="資格情報のお知らせ"
          description=""
        >
          <Certification />
        </NavButton>}
        {config.show_newcard && <NavButton
          isActive={activeTab === "tab4"}
          onClick={() => handleClick("tab4")}
          id="tabs-with-card-item-4"
          controls="tabs-with-card-4"
          title="資格確認書"
          description=""
        >
          <Card2Icon />
        </NavButton>}
      </nav>
    </div>
  );
}

export default Nav;
